// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__tjESj","legacyBtn":"MutateMid_legacyBtn__2hfoM"};